import {
  Image as ChakraImage,
  ImageProps as ChakraImageProps,
} from '@chakra-ui/react'
import { SwashbuckleComponentProps } from '../../types'

type OmittedImageProps =
  | 'align'
  | 'crossOrigin'
  | 'fallback'
  | 'fallbackSrc'
  | 'fallbackStrategy'
  | 'fit'
  | 'htmlHeight'
  | 'htmlWidth'
  | 'ignoreFallback'
  | 'loading'
  | 'onError'
  | 'onLoad'
  | 'sizes'

export type ImageProps = Omit<
  SwashbuckleComponentProps<ChakraImageProps>,
  OmittedImageProps
>

const fallbackDataUri =
  "data:image/svg+xml,%3Csvg fill='none' height='150' viewBox='0 0 150 150' width='150' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3CradialGradient id='a' cx='0' cy='0' gradientTransform='matrix(0 27.587 -36.2571 0 75.1957 60.8044)' gradientUnits='userSpaceOnUse' r='1'%3E%3Cstop offset='0' stop-color='%23fff' stop-opacity='.58'/%3E%3Cstop offset='1' stop-color='%23fff' stop-opacity='.15'/%3E%3C/radialGradient%3E%3CclipPath id='b'%3E%3Cpath d='m0 0h150v150h-150z'/%3E%3C/clipPath%3E%3Cg clip-path='url(%23b)'%3E%3Cpath d='m0 0h150v150h-150z' fill='%23808080' opacity='.5'/%3E%3Cpath d='m61 61c-2.2091 0-4 1.7909-4 4v19.3913c0 2.2091 1.7909 4 4 4h28c2.2091 0 4-1.7908 4-4v-19.3913c0-2.2091-1.7909-4-4-4zm-1.6521 4.3479c0-1.1046.8954-2.0001 2-2.0001h27.3043c1.1045 0 2 .8955 2 2v16.0979l-6.1752-6.7622c-.2385-.2614-.6007-.4051-.9538-.379-.2904.0214-.5717.1543-.7704.3668l-5.3069 5.6371-7.8261-8.7433c-.2369-.2659-.5991-.4142-.9538-.3913-.295.0184-.5808.1513-.7826.3669l-8.5351 9.1714zm18.3912 1.1304c-1.9305 0-3.5217 1.5912-3.5217 3.5217s1.5912 3.5217 3.5217 3.5217c1.9306 0 3.5218-1.5912 3.5218-3.5217s-1.5912-3.5217-3.5218-3.5217zm0 2.3478c.6619 0 1.1739.5121 1.1739 1.1739 0 .6619-.512 1.1739-1.1739 1.1739-.6618 0-1.1739-.512-1.1739-1.1739 0-.6618.5121-1.1739 1.1739-1.1739zm-9.0242 5.2583 10.6998 11.9591h-18.1711c-1.0468 0-1.8954-.8486-1.8954-1.8954zm14.8817 3.1183 7.0556 7.7282c0 .6146-.4982 1.1128-1.1128 1.1128h-6.97l-3.5585-3.9741z' fill='url(%23a)' opacity='.5'/%3E%3C/g%3E%3C/svg%3E"

export const Image = ({
  'data-qa': dataQa,
  className,
  ...chakraProps
}: ImageProps) => {
  return (
    <ChakraImage
      data-qa={dataQa}
      className={className}
      fallbackSrc={fallbackDataUri}
      {...chakraProps}
    />
  )
}

Image.displayName = 'Image'
